import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AccountApp } from './AccountApp';
import { createAccountApi } from './api';
import { createFirebaseAccountAuth, firebaseConfigFromEnv } from './firebaseAuth';
import './account.css';

// The API base is baked at build time so the same bundle cannot be pointed at a
// different backend by whoever serves it.
const firebaseConfig = firebaseConfigFromEnv();
const api = createAccountApi({
  apiBaseUrl: import.meta.env.VITE_LENS_API_URL as string | undefined,
  firebaseAuth: firebaseConfig ? createFirebaseAccountAuth(firebaseConfig) : null,
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AccountApp api={api} />
  </StrictMode>,
);
